module.exports = __webpack_public_path__ + "static/email-logo2-80ba4ee9883501b5ccdb25e545911399.png";